import { useContext } from "react";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { toast } from "react-toastify";
import { getJourneyAccessLink } from "@/modules/lead-page/api/lead-page.v2.api";
import { useQuery } from "@tanstack/react-query";

const useCopyAccessLink = () => {
  const { lead } = useContext(LeadPageContext);
  const journeyUId = lead?.data?.lead?.journey_uid;

  const { refetch: onCopyAccessLink, isFetching: isLoading } = useQuery({
    queryKey: ["journey-access-link", journeyUId],
    queryFn: async () => {
      if (!journeyUId) {
        throw new Error("No lead journey ID available");
      }
      return getJourneyAccessLink(journeyUId);
    },
    enabled: false, // Only fetch when manually triggered via refetch()
    onSuccess: async (response) => {
      const leadUrl = response?.data?.redirectUrl;

      if (!leadUrl) {
        toast.error("Failed to get access link");
        return;
      }

      await navigator.clipboard.writeText(leadUrl);

      toast.success("Access link copied", {
        position: "bottom-left",
        autoClose: 2000,
      });
    },
    onError: (_error: any) => {
      toast.error("Failed to copy access link", {
        position: "bottom-left",
        autoClose: 2000,
      });
    },
  });

  return {
    onCopyAccessLink,
    isLoading,
  };
};

export default useCopyAccessLink;

